import { Box, IconButton, Typography } from "@mui/material";
import { ArrowForwardIosRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Icons from "@/assets";
import { getDisplayImage } from "@/utils/helper";
import { Contribution } from "@/types/common";
import BaseCard from "@/shared/components/BaseCard";
import { FONT_SIZES } from "@/shared/constants/typography";
import PlaceThumbnail from "@/shared/components/PlaceThumbnail";
import { getStatusColor, getStatusLabel } from "@/shared/constants/status";

const ContributionCard = ({ data, from = "profile" }: { data: Contribution; from?: string }) => {
  const navigate = useNavigate();
  const { place, media = [] } = data;

  const statusColor = getStatusColor(data.status);

  return (
    <BaseCard
      onClick={() => {
        navigate(`/contribution/view/${data.contribution_id}`, {
          state: { from },
        });
      }}
      sx={{
        py: "4%",
        px: "3%",
        cursor: "pointer",
      }}
    >
      {(data.status === "reviewed" || data.is_best) && (
        <Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
          <Box
            component="img"
            src={data.is_best ? Icons.Seleted : Icons.NotSelected}
          ></Box>
          <Typography
            sx={{ fontSize: FONT_SIZES.CAPTION, color: "#626262" }}
          >
            {data.is_best
              ? "Added to place details"
              : "Not added to place details due to data mismatch"}
          </Typography>
        </Box>
      )}
      {data.status === "replaced" && !data.is_best && (
        <Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
          <Box component="img" src={Icons.Info} sx={{ width: 16, height: 16 }}></Box>
          <Typography sx={{ fontSize: FONT_SIZES.CAPTION, color: "#626262", fontWeight: 500 }}>
            Replaced by a newer best contribution
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: "1%",
        }}
      >
        <Box sx={{ width: "15%" }}>
          <PlaceThumbnail
            src={getDisplayImage(media)}
            alt={place.name}
          />
        </Box>

        <Box sx={{ width: "55%" }}>
          <Typography
            sx={{
              fontSize: FONT_SIZES.SUBTITLE,
              textWrap: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            {place.name}
          </Typography>
          <Typography
            sx={{
              fontSize: FONT_SIZES.CAPTION,
              textWrap: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              mt: "0.5%",
            }}
          >
            {place.address_text}
          </Typography>
        </Box>

        <Box sx={{ width: "25%", textAlign: "right" }}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                sx={{
                  fontSize: FONT_SIZES.CAPTION,
                  fontWeight: 700,
                  textWrap: "nowrap",
                  color: statusColor,
                }}
              >
                {getStatusLabel(data.status)}
              </Typography>

              <IconButton
                size="small"
                sx={{ p: 0 }}
              >
                <ArrowForwardIosRounded
                  fontSize="small"
                  sx={{ color: "#626262", fontSize: 14 }}
                />
              </IconButton>
            </Box>

            {data.is_updated && data.status === "pending" && (
              <Typography
                sx={{
                  fontSize: FONT_SIZES.CAPTION,
                  color: "#939393",
                  textAlign: "right",
                  mt: 0.5,
                }}
              >
                {"(Edited)"}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </BaseCard>
  );
};

export default ContributionCard;
